import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Login from '../components/Login/Login';
import Consent from '../components/Consent/Consent';
import PreviewPdf from '../components/Consent/PreviewPdf';
import Esign from '../components/Consent/Esign';
import PdfReview from '../components/Consent/PdfReview';
import PdfReview2 from '../components/Consent/PdfPreview2';
import ProductInfo from '../components/ProductInfo/ProductInfo';
import Dashboard from '../components/Dashboard/Dashboard';
import Contact from '../components/Contact/Contact';
import Notification from '../components/Notification/Notification';
import FAQs from '../components/FAQs/FAQs';
import Settings from '../components/Settings/Settings';
import ProfileChange from '../components/Settings/ProfileChange';
import SupportRequest from '../components/Settings/SupportRequest';
import ManageNotification from '../components/Settings/ManageNotification';
import LanguageSelection from '../components/Login/LanguageSelection';
import Dpcextra from '../components/Dashboard/Dpcextra';
import ExplanationOfBenifitaHistoryDetails from '../ExplanationOfBeniftsHistory/ExplanationOfBenifitaHistoryDetails';
import AppStoreRedirect from '../redirection/AppStoreRedirect';

const NoMatch = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/');
  }, [navigate]);

  return null;
};

export const getRoutes = () => {
  const isAuthenticated = !!localStorage.getItem("token");
  return [
    {
      element: Dashboard,
      path: '/dashboard',
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Dpcextra,
      path: '/dpcextra',
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Login,
      path: '/login',
      isPrivate: false,
      isLayout: false,
    },
    {
      element: Consent,
      path: '/consent',
      isPrivate: false,
      isLayout: false,
    },
    {
      element: PreviewPdf,
      path: '/preview-pdf',
      isPrivate: false,
      isLayout: false,
    },
    {
      element: Esign,
      path: '/eSign',
      isPrivate: false,
      isLayout: false,
    },
    {
      element: PdfReview,
      path: '/pdf-review',
      isPrivate: false,
      isLayout: false,
    },
    {
      element: PdfReview2,
      path: '/show-sign-document',
      isPrivate: false,
      isLayout: false,
    },
    {
      element: ProductInfo,
      path: '/product-info',
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Contact,
      path: '/contact',
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Notification,
      path: '/notification',
      isPrivate: true,
      isLayout: false,
    },
    {
      element: FAQs,
      path: '/FAQs',
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Settings,
      path: '/settings',
      isPrivate: true,
      isLayout: true,
    },
    {
      element: ProfileChange,
      path: '/profile-change',
      isPrivate: true,
      isLayout: true,
    },
    {
      element: SupportRequest,
      path: '/support-request',
      isPrivate: isAuthenticated,
      isLayout: isAuthenticated,
    },
    {
      element: ExplanationOfBenifitaHistoryDetails,
      path: '/explanation-of-benifits-history',
      isPrivate: true,
      isLayout: false,
    },
    {
      element: ManageNotification,
      path: '/manage-notification',
      isPrivate: true,
      isLayout: true,
    },
    {
      element: LanguageSelection,
      path: '/',
      isPrivate: false,
      isLayout: false,
    },
    {
      element: AppStoreRedirect,
      path: '/download-app',
      isPrivate: false,
      isLayout: false,
    },
    {
      path: '*',
      element: NoMatch,
    },
  ];
};
